/*
  Basket overlay (16 Oct, Martyn): Horizon's basket drawer opens without a backdrop, so this adds a dimmed scrim
  behind it (styled in assets/wss-overlay.css). Clicking the scrim or pressing Escape closes the basket.
*/
(function () {
  'use strict';
  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || document.querySelector('.wss-scrim')) return;
    var scrim = document.createElement('div');
    scrim.className = 'wss-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
    function isOpen() { var d = drawer.querySelector('dialog'); return drawer.hasAttribute('open') || !!(d && d.open); }
    function close() { if (typeof drawer.close === 'function') drawer.close(); }
    function sync() { document.documentElement.classList.toggle('wss-drawer-open', isOpen()); }
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    new MutationObserver(sync).observe(drawer, { attributes: true, subtree: true, attributeFilter: ['open'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
